import React, { FC } from 'react'

const DmnIcon: FC<{ className?: string }> = ({ className }) => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M1 6C1 4.89543 1.89543 4 3 4H21.5C22.6046 4 23.5 4.89543 23.5 6V19C23.5 20.1046 22.6046 21 21.5 21H3C1.89543 21 1 20.1046 1 19V6ZM21.5 6H3V9H21.5V6ZM21.5 11H9V14H21.5V11ZM21.5 16H9V19H21.5V16ZM7 19V16H3V19H7ZM7 14V11H3V14H7Z'
        fill='black'
      />
    </svg>
  )
}

export default DmnIcon
